import { formatDateString } from "@via/utils/helpers.tsx";
import { type JSX } from "react";

/**
 * Formats a field value for display in the table based on its type
 * @param value The field value to format
 * @param fieldType The type of the field (e.g., "String", "Number", "Boolean", "Date")
 * @returns Formatted JSX element or string for display
 */
export function formatFieldValue(
  value: any,
  fieldType: string
): string | JSX.Element {
  if (value === null || value === undefined || value === "") {
    return <span className="text-gray-400 text-center mx-5">-</span>;
  }

  switch (fieldType.toLowerCase()) {
    case "boolean":
      return (
        <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800">
          {value ? "true" : "false"}
        </span>
      );
    case "date":
      return (
        <span className="text-sm text-gray-700">
          {formatDateString(value, "LL")}
        </span>
      );
    case "number":
      return <span className="text-sm text-gray-700">{String(value)}</span>;
    case "string":
    default:
      return <span className="text-sm text-gray-700">{String(value)}</span>;
  }
}
